import { SUPPORT_CENTER_ITEMS } from "@/base/NewselaGlobalLayoutV2/NavigationBar/shared/constants";
import { SupportCenterItem } from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterItem";
import {
  popoutContainerCss,
  supportCenterUnorderedListCss,
  supportTitleCss,
} from "@/base/NewselaGlobalLayoutV2/NavigationBar/SupportCenter/SupportCenterPopout/SupportCenterPopout.styles";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";

const SupportCenterPopout = () => {
  const { data: user } = useUser();
  const userProperties = getUserProperties(user, {
    shouldUseNewUserApi: false,
  });

  return (
    <div css={popoutContainerCss}>
      <div css={supportTitleCss}>Support</div>

      <ul css={supportCenterUnorderedListCss}>
        {SUPPORT_CENTER_ITEMS.filter((item) =>
          typeof item.enabled === "function"
            ? item.enabled(user, userProperties)
            : item.enabled,
        ).map(({ title, href, openInNewTab, ItemIcon }, index) => (
          <SupportCenterItem
            title={title}
            href={href}
            ItemIcon={ItemIcon}
            openInNewTab={openInNewTab}
            key={index}
          />
        ))}
      </ul>
    </div>
  );
};

SupportCenterPopout.displayName = "SupportCenterPopout";
export { SupportCenterPopout };
